import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Styles/passwordReset.css"
import loader from "../Images/confirmation-loader.gif"
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

export const PasswordReset = () => {
    const [loading, setLoading] = useState(false);
    const [allowAccess, setAllowAccess] = useState(false);
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [request, setRequest] = useState(null);

    useEffect(() => {
        document.title = "Réinitialisation du mot de passe - KabaaShop"

        const queryParameters = new URLSearchParams(window.location.search);

        var token = queryParameters.get("token");

        if (token == null) {
            window.location.href = '/';
        }
        else {
            axios.get(process.env.REACT_APP_API_BASE_URL + '/api/password_reset_requests?token=' + token,
                {
                    headers: {
                        'x-api-token': process.env.REACT_APP_API_TOKEN,
                    }
                }).then(a => {
                    if (a.data.length == 0) {
                        toast.error('Une erreur est survenue');
                    }
                    else if (a.data[0].confirmedAt != null) {
                        toast.error('Requête déjà traitée !');
                    }
                    else {
                        setAllowAccess(true);

                        setRequest(a.data[0]);
                    }
                }).catch(error => {
                    toast.error('Une erreur est survenue');
                })
        }

    }, [true])

    const handleSubmit = () => {
        if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/)) {
            toast.error("Le mot de passe doit contenir au moins 1 lettre majuscule, 1 lettre minuscule et 1 chiffre et avoir au minimum 8 caractères")
            return;
        }

        if (password !== confirm) {
            toast.error("Le mot de passe n'a pas été confirmé !")
            return;
        }

        setLoading(true);

        axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/password_reset_requests/'+request.id,
            {
                confirmedAt: new Date()
            },
            {
                headers: {
                    'x-api-token': process.env.REACT_APP_API_TOKEN,
                }
            }).then(a => {

                axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/users/'+request.user.id,
                    {
                        password: password
                    },
                    {
                        headers: {
                            'x-api-token': process.env.REACT_APP_API_TOKEN,
                        }
                    }).then(a => {
                        setLoading(false)
                        setPassword('')
                        setConfirm('')
                        toast.success('Votre mot de passe a bien été modifié ! Vous serez rediriger dans un instant !')
                        
                        setTimeout(()=>{
                            window.location.href = '/connexion';
                        }, 2500)
                    }).catch(error => {
                        toast.error('Une erreur est survenue');
                    })

            }).catch(error => {
                toast.error('Une erreur est survenue');
            })
    }

    return (
        <>
            <ToastContainer />
            <div className="password-reset-page">
                {
                    !allowAccess ?
                        <div className="loading-image">
                            <img src={loader} alt="loading"/>
                        </div> :
                        <div className="password-reset-form">
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit()
                            }}>
                                <h2 style={{ marginBottom: '15px' }}>Vous y êtes presque !</h2>
                                <TextField required value={password} onChange={(e) => {
                                    setPassword(e.target.value)
                                }} disabled={loading} sx={{ marginBottom: '15px', background: 'white' }} placeholder="Nouveau mot de passe" type="password" variant="outlined" />
                                <TextField required value={confirm} onChange={(e) => {
                                    setConfirm(e.target.value)
                                }} disabled={loading} sx={{ marginBottom: '25px', background: 'white' }} placeholder="Confirmer le mot de passe" type="password" variant="outlined" />
                                <Button type="submit" disabled={loading} sx={{ background: '#292A5C' }} variant="contained" size="large">Confirmer</Button>
                            </form>
                        </div>
                }
            </div>

        </>
    );
};
